export const GET_APPEAL_APPLICATION_RECORDS = 'GET_APPEAL_APPLICATION_RECORDS';
export const GET_APPEAL_FEES = 'GET_APPEAL_FEES';
export const GET_AVAILABLE_RESULTS = 'GET_AVAILABLE_RESULTS';
export const GET_APPEAL_LISTING = 'GET_APPEAL_LISTING';
export const POST_APPEAL_DRAFT = 'POST_APPEAL_DRAFT';
export const GET_APPEAL_DRAFT_REVIEW = 'GET_APPEAL_DRAFT_REVIEW';
export const GET_APPEAL_RECEIPT_SUMMARY = 'GET_APPEAL_RECEIPT_SUMMARY';
export const GET_APPEAL_SUMMARY_PDF = 'GET_APPEAL_SUMMARY_PDF';
export const GET_APPEAL_RECEIPT = 'GET_APPEAL_RECEIPT';
export const POST_PROCEED_TO_PAY = 'POST_PROCEED_TO_PAY';
export const POST_APPEAL_ELIGIBILITY_CHECK = 'POST_APPEAL_ELIGIBILITY_CHECK';
